var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 75,
    viewBox: "0 0 152 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3673_16457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 42,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2865 34.4645L32.6289 48.0366L46.2865 61.6087H30.6798L17.0173 48.0366L30.6798 34.4645H46.2865ZM30.6798 11.207L5.31348 36.4054L13.1193 44.1595L46.2865 11.207H30.6798Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3673_16457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8214 55.791L46.2849 34.4648H30.6782L17.0205 48.0369L24.8214 55.791Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3673_16457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 42,
    height: 51
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2865 34.4645L32.6289 48.0366L46.2865 61.6087H30.6798L17.0173 48.0366L30.6798 34.4645H46.2865ZM30.6798 11.207L5.31348 36.4054L13.1193 44.1595L46.2865 11.207H30.6798Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3673_16457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31348 36.4054L30.6798 11.207H46.2865L13.1193 44.1595L5.31348 36.4054Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3673_16457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 42,
    height: 51
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2865 34.4645L32.6289 48.0366L46.2865 61.6087H30.6798L17.0173 48.0366L30.6798 34.4645H46.2865ZM30.6798 11.207L5.31348 36.4054L13.1193 44.1595L46.2865 11.207H30.6798Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3673_16457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6781 61.6063H46.2848L32.6271 48.0391L24.8213 55.7932L30.6781 61.6063Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3673_16457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 42,
    height: 51
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2865 34.4645L32.6289 48.0366L46.2865 61.6087H30.6798L17.0173 48.0366L30.6798 34.4645H46.2865ZM30.6798 11.207L5.31348 36.4054L13.1193 44.1595L46.2865 11.207H30.6798Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3673_16457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6271 48.0391L24.8213 55.7932L36.3981 51.8094L32.6271 48.0391Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3673_16457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 42,
    height: 51
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2865 34.4645L32.6289 48.0366L46.2865 61.6087H30.6798L17.0173 48.0366L30.6798 34.4645H46.2865ZM30.6798 11.207L5.31348 36.4054L13.1193 44.1595L46.2865 11.207H30.6798Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3673_16457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0205 48.0356L24.8265 40.2812L32.633 48.0356L24.8265 55.7899L17.0205 48.0356Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2865 34.4645L32.6289 48.0366L46.2865 61.6087H30.6798L17.0173 48.0366L30.6798 34.4645H46.2865ZM30.6798 11.207L5.31348 36.4054L13.1193 44.1595L46.2865 11.207H30.6798Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2393 24.7188H64.8796V27.3687H54.0076V35.3862H63.8226V38.0037H54.0076V48.1475H51.2393V24.7188ZM68.1802 24.7188H70.98V48.1488H68.1802V24.7188ZM81.2228 48.6725C79.2028 48.6725 77.6508 48.0833 76.567 46.905C75.5201 45.7192 74.9966 44.0721 74.9966 41.9637V31.46H77.7964V41.5387C77.7964 43.1221 78.1588 44.2887 78.8836 45.0387C79.6084 45.7887 80.5857 46.1637 81.8155 46.1637C82.7601 46.1637 83.599 45.9129 84.3322 45.4112C85.0872 44.9096 85.6576 44.2554 86.0435 43.4487C86.4604 42.6404 86.6689 41.7896 86.6689 40.8962V31.4713H89.4674V48.1587H86.7998V45.7262H86.6676C86.2062 46.5554 85.4705 47.2533 84.4605 47.82C83.4505 48.3867 82.3742 48.67 81.2316 48.67L81.2228 48.6725Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.243 48.4138C99.5618 48.4138 98.925 48.3046 98.3328 48.0863C97.7623 47.8679 97.2791 47.5733 96.8832 47.2025C96.4436 46.7883 96.1143 46.3083 95.8954 45.7625C95.6756 45.2175 95.5657 44.5521 95.5657 43.7662V33.9825H92.6338V31.4625H95.5657V26.75H98.3655V31.4625H102.45V33.9825H98.3655V43.08C98.3655 43.9967 98.5417 44.6729 98.894 45.1087C99.3109 45.5888 99.9149 45.8288 100.706 45.8288C101.344 45.8288 101.958 45.6433 102.551 45.2725V47.9888C102.221 48.1413 101.88 48.2504 101.529 48.3163C101.199 48.3829 100.771 48.4163 100.245 48.4163L100.243 48.4138Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.118 48.4138C111.437 48.4138 110.8 48.3046 110.208 48.0863C109.637 47.8679 109.154 47.5733 108.758 47.2025C108.319 46.7883 107.989 46.3083 107.77 45.7625C107.551 45.2175 107.441 44.5521 107.441 43.7662V33.9825H104.509V31.4625H107.441V26.75H110.24V31.4625H114.325V33.9825H110.24V43.08C110.24 43.9967 110.417 44.6729 110.769 45.1087C111.186 45.5888 111.79 45.8288 112.581 45.8288C113.219 45.8288 113.833 45.6433 114.426 45.2725V47.9888C114.096 48.1413 113.755 48.2504 113.404 48.3163C113.074 48.3829 112.646 48.4163 112.12 48.4163L112.118 48.4138Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.451 48.6723C122.857 48.6723 121.418 48.2907 120.135 47.5273C118.861 46.764 117.862 45.7169 117.137 44.3861C116.434 43.0336 116.083 41.5169 116.083 39.8361C116.083 38.2219 116.412 36.7386 117.071 35.3861C117.752 34.0336 118.707 32.9536 119.937 32.1461C121.167 31.3378 122.594 30.9336 124.219 30.9336C125.866 30.9336 127.293 31.3086 128.501 32.0586C129.709 32.7786 130.632 33.7819 131.27 35.0686C131.928 36.3561 132.258 37.8286 132.258 39.4861C132.258 39.8136 132.224 40.0969 132.157 40.3361H118.882C118.949 41.6011 119.256 42.6703 119.804 43.5436C120.353 44.4161 121.045 45.0703 121.88 45.5061C122.736 45.9428 123.625 46.1611 124.548 46.1611C126.7 46.1611 128.358 45.1578 129.522 43.1511L131.894 44.2961C131.169 45.6486 130.181 46.7178 128.929 47.5036C127.7 48.2886 126.206 48.6811 124.45 48.6811L124.451 48.6723ZM129.293 38.0373C129.249 37.339 129.052 36.6411 128.702 35.9436C128.349 35.2453 127.789 34.6561 127.022 34.1761C126.267 33.6961 125.323 33.4561 124.19 33.4561C122.873 33.4561 121.753 33.8811 120.831 34.7311C119.931 35.5603 119.337 36.6619 119.051 38.0361H129.297L129.293 38.0373ZM135.502 31.4598H138.169V34.1436H138.301C138.631 33.2269 139.268 32.4744 140.212 31.8861C141.156 31.2753 142.144 30.9698 143.176 30.9698C143.945 30.9698 144.603 31.079 145.152 31.2973V34.3073C144.449 33.9573 143.658 33.7823 142.78 33.7823C141.966 33.7823 141.219 34.0115 140.54 34.4698C139.859 34.9282 139.314 35.5498 138.904 36.3348C138.51 37.0982 138.313 37.9315 138.313 38.8348V48.1598H135.513V31.4723L135.502 31.4598Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/Flutter.b977452538fbc7af4a701066133f92dd.svg";
export { ForwardRef as ReactComponent };